<template>
  <div class="position-container">
    <ExOrgPosition
      ref="exorgposition"
      :modalHeaderState="positionHeaderState"
      :menuItems="menuItemsProp"
      :tableData="paginatedAttachedRoles"
      :dataStream="positionChatter"
      @onButtonAction="openRoleToPosition"
      @onRequest="requestRoleData"
      @onSearchMode="searchMode = $event"
      @onLoadMore="getPositionChatter(accountId)"
      @requestMoreCheckpointsChatter="getPositionChatter(accountId)"
      :show-load-more="totalChatterData > positionChatter.length"
      :totalChatterCount="totalChatterData"
      @optionClick="handleDropdownClick($event, currentPosition)"
      :pagination="paginationOrgRoleModel"
      @roleDropdownClick="handleRoleDropdownClick($event)"
      :currentPosition="currentPosition"
      @openAssignmentModal="openAssignmentModal"
      @detachItem="callDetachItems($event)"
      :detachLoading="detachLoader"
      @sequenceReorder="reOrderData($event)"
      @reloadChatterList="reloadChatterList"
      :allStoreRoles="storeRoles"
      @appliedFilterFromAPI="appliedFilterFromAPI"
      @searchTextData="searchTextData"
      :isShowLoader="isShowLoader"
    />
    <AttachedRole
      v-model="showRoleToPosition"
      OrgObjectType="Role to Position"
      @onSave="attachedRole"
      :items="attachRolesForPosition"
      @item-selected="handleItemSelected"
      :existingNamesList="[]"
      @add-item-selected="addHandleItemSelected"
      :parent-name="(currentPosition && currentPosition.name) || ''"
      :openDefault="openDefault"
      @input="onAttachedCloseModal"
      :showError="showAttachError"
      :isLoadingMore="isLoadingMore"
      :hasMoreData="hasMoreData"
      @load-more="loadMoreRolesForPosition"
      @search="searchRolesForPosition"
      :type="
        showAttachResponsibilitiesPicker
          ? 'attach_role_to_position_new_picker'
          : 'attach_role_to_position'
      "
      :isAssigning="isAssigningObject"
      :position="addAndAttachPosition"
      @created-and-attached="handleRoleCreatedAndAttached"
    />
    <ExOrgObjectActions
      v-model="showActivatePositionDialog"
      objectType="Position"
      :name="(currentPosition && currentPosition.name) || ''"
      @onAction="activatePosition"
    />
    <RenameOrgObject
      v-if="showRenamePositionDialog"
      :openDialog="showRenamePositionDialog"
      :name="(currentPosition && currentPosition.name) || ''"
      OrgObjectType="Position"
      :placeholder="(currentPosition && currentPosition.name) || ''"
      :apiError="renamePositionError"
      :duplicateNotAllowed="false"
      @clearApiError="renamePositionError = ''"
      @onAction="renamePosition($event)"
      @onClose="
        showRenamePositionDialog = false;
        renamePositionError = '';
      "
      :isShowCharCounter="true"
      :maxWidth="'430'"
    />
    <ExDeActivatePopup
      v-model="showDeActivatePositionDialog"
      OrgObjectType="Position"
      :name="(currentPosition && currentPosition.name) || ''"
      @onAction="deActivatePosition"
    />
    <ReActivatePosition
      v-model="showReActivatePositionDialog"
      OrgObjectType="Position"
      :name="(currentPosition && currentPosition.name) || ''"
      @onAction="reActivatePosition"
    />
    <ExCloneOrgObject
      v-model="showClonedPositionDialog"
      OrgObjectType="Position"
      :name="(currentPosition && currentPosition.name) || ''"
      @onAction="clonePosition"
    />
    <ExDeleteOrgObject
      v-model="showDeletePositionDialog"
      OrgObjectType="Position"
      :name="(currentPosition && currentPosition.name) || ''"
      @onAction="deletePosition"
    />
    <RetirePositionPopup
      v-model="showRetirePositionDialog"
      OrgObjectType="Position"
      :name="(currentPosition && currentPosition.name) || ''"
      @onAction="retirePosition"
    />
    <ExAssignmentsModal
      :dialog="showAssignmentsModal"
      @cancel="showAssignmentsModal = false"
      :assignedEmployees="assignments"
    />
    <DetachDialog
      v-model="showDetachDialog"
      :position="parentName || ''"
      :role="currentRole || {}"
      @onAction="detachAction"
    />
    <ArchivePopUp
      :action="archiveAction"
      :type="'position'"
      :show="showArchivedPositionDialog"
      :curretObj="currentPosition"
      :errorMessage="archivePositionError"
      @onClose="onCloseArchivePositionDialog"
      @onArchive="onArchivePosition"
    ></ArchivePopUp>
  </div>
</template>
<script>
/* eslint-disable */
import ExOrgPosition from "@components/OrgnationPosition/ExOrgPosition.vue";
import {
  attachRoleToPosition,
  getChatterList,
  getPositionId,
  clonePosition as clonePositionAPI,
  updatePosition,
  activatePosition,
  deletePosition,
  deActivatePosition,
  reActivatePosition,
  retirePosition,
  detachRoleAttachment,
  detachAttachments,
  reOrderSequenceData,
  archivePosition,
  unArchivePosition,
} from "@/api";
import { transformChatterData } from "@/utils/chatterUtils";
import { positionActionErrorMessage } from "@components/utils/positionErrorMessages";
import AttachedRole from "@components/RolesCatalog/AttachedRole.vue";
import responsibilityMixin from "@components/views/mixins/responsibilityMixin";
import roleMixin from "@components/views/mixins/roleMixin";
import { mapState } from "vuex";
import ExOrgObjectActions from "@components/common/ExOrgObjectActions.vue";
import RenameOrgObject from "@components/RenameOrgObject/RenameOrgObject.vue";
import ExDeActivatePopup from "@components/DeActivatePosition/DeActivatePositionPopup.vue";
import ReActivatePosition from "@components/ReActivatePosition/ReActivatePositionPopup.vue";
import ExCloneOrgObject from "@components/CloneOrgObject/ExCloneOrgObject.vue";
import ExDeleteOrgObject from "@components/DeleteOrgObject/ExDeleteOrgObject.vue";
import RetirePositionPopup from "@components/RetirePositionPopup/RetirePositionPopup.vue";
import ExAssignmentsModal from "@components/ExAssignmentModal/ExAssignmentModal.vue";
import DetachDialog from "@components/DetachDialog/DetachDialog.vue";
import ArchivePopUp from "@components/common/ArchivePopUp.vue";
export default {
  components: {
    ExOrgPosition,
    AttachedRole,
    ExOrgObjectActions,
    RenameOrgObject,
    ExDeActivatePopup,
    ReActivatePosition,
    ExCloneOrgObject,
    ExDeleteOrgObject,
    RetirePositionPopup,
    ExAssignmentsModal,
    DetachDialog,
    ArchivePopUp,
  },
  mixins: [responsibilityMixin, roleMixin],
  data() {
    return {
      positionHeaderState: null,
      currentPosition: null,
      searchMode: false,
      matchedData: [],

      showRoleToPosition: false,
      positionChatter: [],
      totalChatterData: 0,
      positionId: null,
      items: [],
      attachRolesForPosition: [],
      renderIndex: 0,
      showActivatePositionDialog: false,
      showRenamePositionDialog: false,
      showDeActivatePositionDialog: false,
      showReActivatePositionDialog: false,
      showClonedPositionDialog: false,
      showDeletePositionDialog: false,
      showRetirePositionDialog: false,
      showArchivedPositionDialog: false,
      showDetachDialog: false,
      currentRole: null,
      showAssignmentsModal: false,
      assignments: [],
      parentName: null,
      openDefault: false,
      archiveAction: null,
      archivePositionError: "",
      renamePositionError: "",
      loadedPages: {},
      showAttachError: "",
      currentSearchTerm: "",
      appliedFiltersFromAPIForPosition: [],
      isShowLoader: false,
      currentPositionId: null,
      hasMoreData: false,
      isLoadingMore: false,
      isAssigningObject: false,
    };
  },
  computed: {
    ...mapState("readinessCatalogsStore", {
      storeRoles: (state) => state.roles,
      showAttachResponsibilitiesPicker() {
        return this.$store.getters["featureFlags/ideaMDP389"];
      },
    }),
    addAndAttachPosition() {
      const position = this.currentPosition;
      const code = String(position?.code_str ?? position?.code ?? "")
        .trim()
        .replace(/^#/, "")
        .split(" ")[0];
      if (!position?.id || !position?.name || !code) return null;
      return { id: position.id, code, name: position.name };
    },
    paginatedAttachedRoles() {
      const tempArray = this.sanitizedItems;
      return tempArray;
    },
    sanitizedItems() {
      let rolesArray = [];
      if (this.storeRoles && this.storeRoles.length > 0) {
        rolesArray = this.storeRoles.map((el) => {
          // Check if role has responsibilities attached
          const hasResponsibilities = el.responsibility_attachment_count > 0;

          return {
            id: el.id,
            parentId: -1,
            status: el.status,
            archived: el.archived,
            has_items: hasResponsibilities,
            type: "role",
            data: {
              type: "role",
              code: el.code + "",
              name: el.name,
              status: el.status,
            },
            info: {
              ...el,
            },
          };
        });
      }

      // Update pagination model using nextTick to avoid side effect warning
      const rolesCount = this.$store.state.readinessCatalogsStore.rolesCount || rolesArray.length;
      if (this.paginationOrgRoleModel.total !== rolesCount) {
        this.$nextTick(() => {
          this.paginationOrgRoleModel.total = rolesCount;
        });
      }

      // For server-side pagination, return all available data since server handles pagination
      // The server already sent us the correct page data in storeRoles
      return rolesArray;
    },
    menuItemsProp() {
      // Count from store roles directly to get total count, not paginated count
      const totalActiveRoles = this.storeRoles?.filter((el) => el?.status === "active").length || 0;

      return [
        {
          title: "Roles attached",
          count: totalActiveRoles,
        },
        {
          title: "Assignments",
          count: 0,
        },
        { title: "Description", count: 0 },
        { title: "Chatter", count: this.totalChatterData ?? 0 },
      ];
    },
  },
  async mounted() {
    this.$loader.show();
    let storeFilterKey = "organizationPositionRoleAttachmentrole";
    await this.$store.dispatch("filterStore/loadFilters", storeFilterKey);
    const savedFilters = this.$store.state.filterStore.filters;
    this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
    this.currentPositionId = this.$route.params.pId;
    await this.loadPositionByID(this.accountId, this.$route.params.pId);
    this.appliedFiltersFromAPIForPosition = savedFilters;
    await this.loadRolesAttachedToPosition({
      limit: 10,
      offset: 0,
      search: "",
      filters: savedFilters || [],
      page: 1,
      positionId: this.$route.params.pId,
    });
    // Hide loader after all data is loaded
    this.$loader.hide();
  },
  methods: {
    async reloadChatterList() {
      this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
      this.positionChatter = [];
      this.totalChatterData = 0;
      if (this.loadedPages[this.$route.params.pId]) {
        delete this.loadedPages[this.$route.params.pId];
      }
      await this.getPositionChatter(this.accountId);
    },
    async reOrderData(reOrderData) {
      try {
        await reOrderSequenceData(this.accountId, reOrderData.roleId, reOrderData.reordered_ids);
      } catch (e) {
        console.log("e: ", e);
      }
    },
    callDetachItems(data) {
      this.detachItems(data, async () => {
        if (data.callBackFunc && typeof data.callBackFunc === "function") {
          data.callBackFunc();
        }
      });
    },
    handleDropdownClick(data, row) {
      switch (data.item.value) {
        case "activate_action":
          this.showActivatePosition(row);
          break;
        case "delete_action":
          this.showDeletePosition(row);
          break;
        case "rename_action":
          this.showRenamePosition(row);
          break;
        case "attach_position_role":
          this.openRoleToPosition(row);
          break;
        case "retire_action":
          this.showRetirePosition(row);
          break;
        case "deactivate_action":
          this.showDeActivatePosition(row);
          break;
        case "reactivate_action":
          this.showReActivatePosition(row);
          break;
        case "cloned_action":
          this.showClonedPosition(row);
          break;
        case "archive_action":
          this.archivePositionError = "";
          this.archiveAction = "archive";
          this.showArchivedPositionDialog = true;
          this.currentPosition = row;
          break;
        case "unarchive_action":
          this.archivePositionError = "";
          this.archiveAction = "unarchive";
          this.showArchivedPositionDialog = true;
          this.currentPosition = row;
          break;
        default:
          break;
      }
    },
    onCloseModal() {
      this.showAddPositionDialog = false;
      this.showActivatePositionDialog = false;
      this.showDeletePositionDialog = false;
      this.showRenamePositionDialog = false;
      this.currentPosition = null;
      this.showPositionRoleDialog = false;
      this.showClonedPositionDialog = false;
      this.showDeActivatePositionDialog = false;
      this.showReActivatePositionDialog = false;
      this.showRetirePositionDialog = false;
      this.showArchivedPositionDialog = false;
      this.archiveAction = null;
    },
    onAttachedCloseModal() {
      this.openDefault = false;
    },
    showActivatePosition(data) {
      this.currentPosition = data;
      this.showActivatePositionDialog = true;
    },
    showRenamePosition(data) {
      this.currentPosition = data;
      this.renamePositionError = "";
      this.showRenamePositionDialog = true;
    },
    showDeActivatePosition(data) {
      this.currentPosition = data;
      this.showDeActivatePositionDialog = true;
    },
    showReActivatePosition(data) {
      this.currentPosition = data;
      this.showReActivatePositionDialog = true;
    },
    showClonedPosition(data) {
      this.currentPosition = data;
      this.showClonedPositionDialog = true;
    },
    showDeletePosition(data) {
      this.currentPosition = data;
      this.showDeletePositionDialog = true;
    },
    showRetirePosition(data) {
      this.currentPosition = data;
      this.showRetirePositionDialog = true;
    },
    async activatePosition() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentPosition?.id;
        if (id) {
          await activatePosition(this.accountId, id);
        }
        this.onCloseModal();
        await this.loadData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("error: ", e);
      }
    },
    async renamePosition(newName) {
      this.renamePositionError = "";
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentPosition?.id;
        if (id) {
          const payload = {
            name: newName,
            account: this.accountId,
          };
          await updatePosition(this.accountId, id, payload);
        }
        this.onCloseModal();
        await this.loadData();
      } catch (e) {
        // MDP-608: keep the rename dialog open with the inline failure.
        this.renamePositionError = positionActionErrorMessage(e, "rename");
        console.log("error: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async deActivatePosition() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentPosition?.id;
        if (id) {
          await deActivatePosition(this.accountId, id);
        }
        this.onCloseModal();
        this.$loader.setAppLoading(false);
        await this.loadData();
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.error("error: ", e);
      }
    },
    async reActivatePosition() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentPosition?.id;
        if (id) {
          await reActivatePosition(this.accountId, id);
        }
        this.onCloseModal();
        await this.loadData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.error("error: ", e);
      }
    },
    async clonePosition() {
      try {
        this.$loader.setAppLoading(true);
        const positionId = this.currentPosition?.id;
        if (!positionId) {
          throw new Error("No position ID available to clone");
        }
        const { data } = await clonePositionAPI(this.accountId, positionId);
        const objId = data.id;

        this.$loader.setAppLoading(false);
        this.onCloseModal();

        this.$router.push(`/organization/positions/position/${objId}`);

        await this.loadData();

        this.filterText = data.code_str || data.code.toString();
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async deletePosition() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentPosition?.id;
        if (id) {
          await deletePosition(this.accountId, id);
        }
        this.$router.push("/organization/positions").catch(() => {});
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("error: ", e);
      }
    },
    async retirePosition() {
      try {
        this.$loader.setAppLoading(true);
        await retirePosition(this.accountId, this.currentPosition?.id);
        this.onCloseModal();
        await this.loadData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("error: ", e);
      }
    },
    async loadData() {
      let storeFilterKey = "organizationPositionRoleAttachmentrole";
      await this.$store.dispatch("filterStore/loadFilters", storeFilterKey);
      const savedFilters = this.$store.state.filterStore.filters;
      this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
      this.currentPositionId = this.$route.params.pId;
      await this.loadPositionByID(this.accountId, this.$route.params.pId);
      await this.loadRolesAttachedToPosition({
        limit: 10,
        offset: 0,
        search: "",
        filters: savedFilters || [],
        page: 1,
        positionId: this.$route.params.pId,
      });
    },
    async getPositionByID() {
      this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
      if (!this.$route.params.pId) this.$router.go(0);
      const { data } = await getPositionId(this.accountId, this.$route.params.pId);
      if (data) {
        this.currentPosition = data;
        console.log(data);
        this.positionHeaderState = {
          status: data.status,
          icon: "org_icon_position",
          label: "Position",
          code: this.getOrgCodeName(data),
          name: data.name,
          archived: data.archived,
          assigned_employees: data.assigned_employees,
        };
      }
    },
    getOrgCodeName(position) {
      if (position?.code_str) {
        return position.code_str.split(" ")[0];
      } else {
        return "#" + position?.code;
      }
    },
    async attachedRole() {
      this.isAssigningObject = true;
      try {
        this.$loader.setAppLoading(true);
        const objId = this.currentPosition?.id;
        const payload = {
          attachment_id: this.attachmentId,
        };
        await attachRoleToPosition(this.accountId, objId, payload);
        this.$loader.setAppLoading(false);
        this.showRoleToPosition = false;
        await this.loadData();
      } catch (e) {
        let errorMessage = e.response.data.message;

        // Extract string from ErrorDetail format if needed
        if (typeof errorMessage === "string" && errorMessage.includes("ErrorDetail")) {
          const match = errorMessage.match(/string='([^']+)'/);
          if (match && match[1]) {
            errorMessage = match[1];
          }
        } else if (Array.isArray(errorMessage) && errorMessage.length > 0) {
          // If it's an array of error objects
          if (typeof errorMessage[0] === "object" && errorMessage[0].string) {
            errorMessage = errorMessage[0].string;
          } else if (typeof errorMessage[0] === "string") {
            errorMessage = errorMessage[0];
          }
        }

        this.showAttachError = errorMessage;
        this.$loader.setAppLoading(false);
      } finally {
        this.isAssigningObject = false;
      }
    },
    async handleRoleCreatedAndAttached() {
      this.showRoleToPosition = false;
      this.showAttachError = "";
      await this.loadData();
    },
    async appliedFilterFromAPI(data) {
      this.appliedFiltersFromAPIForPosition = data;
      try {
        this.$loader.show();
        this.isShowLoader = true;
        await this.loadRolesAttachedToPosition({
          limit: 10,
          offset: 0,
          search: "",
          filters: data,
          page: 1,
          positionId: this.$route.params.pId,
        });
      } catch (error) {
        console.error("Search error:", error);
        // Ensure loader is hidden on error with slight delay
        setTimeout(() => {
          this.isShowLoader = false;
          this.$loader.hide();
        }, 500);
      } finally {
        // Set loader to false after data mapping is complete
        setTimeout(() => {
          this.isShowLoader = false;
          this.$loader.hide();
        }, 500);
      }
    },
    async searchTextData(data) {
      this.currentSearchTerm = data.name;
      try {
        this.$loader.show();
        this.isShowLoader = true;
        await this.loadRolesAttachedToPosition({
          limit: 10,
          offset: 0,
          search: this.currentSearchTerm,
          filters: this.appliedFiltersFromAPIForPosition || [],
          page: 1,
          positionId: this.$route.params.pId,
        });
      } catch (error) {
        console.error("Search error:", error);
        // Ensure loader is hidden on error with slight delay
        setTimeout(() => {
          this.isShowLoader = false;
          this.$loader.hide();
        }, 500);
      } finally {
        // Set loader to false after data mapping is complete
        setTimeout(() => {
          this.isShowLoader = false;
          this.$loader.hide();
        }, 500);
      }
    },
    async requestRoleData(paginationData) {
      try {
        this.$loader.show();
        this.isShowLoader = true;
        // Calculate offset based on page number
        const limit = 10;
        const offset = (paginationData.page - 1) * limit;

        // Call the store function with search parameters
        await this.loadRolesAttachedToPosition({
          limit: limit,
          offset: offset,
          search: this.currentSearchTerm,
          filters: this.appliedFiltersFromAPIForPosition,
          page: paginationData.page,
          positionId: this.$route.params.pId,
        });
      } catch (error) {
        console.error("Search error:", error);
        // Ensure loader is hidden on error with slight delay
        setTimeout(() => {
          this.isShowLoader = false;
          this.$loader.hide();
        }, 500);
      } finally {
        // Set loader to false after data mapping is complete
        setTimeout(() => {
          this.isShowLoader = false;
          this.$loader.hide();
        }, 500);
      }
    },
    openRoleToPosition() {
      this.getListOfRolesForPosition(this.currentPositionId);
      this.showRoleToPosition = true;
      this.openDefault = true;
      this.showAttachError = "";
    },
    handleItemSelected(data) {
      if (data && Object.prototype.hasOwnProperty.call(data, "id")) {
        this.attachmentId = data.id;
      }
    },
    async addHandleItemSelected(data1) {
      try {
        const role = {
          name: data1.name,
          account: this.accountId,
        };
        const newRole = await this.$store.dispatch("readinessCatalogsStore/createRole", {
          role,
          accountId: this.accountId,
        });
        this.attachmentId = newRole.id;
        this.attachedRole();
        await this.refreshData();
      } catch (e) {
        console.log("e: ", e);
      }
    },
    // async refreshData() {
    //   this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
    //   await this.loadPositionByID(this.accountId, this.$route.params.pId);
    //   await this.loadRolesAttachedToPosition({
    //     limit: this.paginationOrgRoleModel.perPage,
    //     offset: (this.paginationOrgRoleModel.page - 1) * this.paginationOrgRoleModel.perPage,
    //     search: this.currentSearchTerm || "",
    //     filters: this.appliedFiltersFromAPI || [],
    //     page: this.paginationOrgRoleModel.page,
    //     positionId: this.$route.params.pId,
    //   });
    // },
    async getPositionChatter(account_id) {
      const posId = this.$route.params.pId;
      const currentLength = this.positionChatter.length;
      const page = Math.floor(currentLength / 10) + 1;
      if (!this.loadedPages[posId]) {
        this.loadedPages[posId] = new Set();
      }
      if (this.loadedPages[posId].has(page)) {
        console.log(`Page ${page} for position ${posId} already loaded.`);
        return;
      }
      const { data } = await getChatterList(account_id, posId, "position", page);
      this.loadedPages[posId].add(page);
      if (data && data.count) {
        this.totalChatterData = data.count;
      }
      if (data && data.results) {
        const chatterItems = transformChatterData(data.results);
        // Add attachments_count which is specific to position chatter
        chatterItems.forEach((item, index) => {
          item.attachments_count = data.results[index].attachments_count;
        });
        this.positionChatter.push(...chatterItems);
      }
    },
    openAssignmentModal(data) {
      this.showAssignmentsModal = true;
      const positions = JSON.parse(localStorage.getItem("exlAppData") || "{}").positions || [];
      let assignedEmployees = [];
      if (data.info) {
        const positionIds = data.info.attachments
          .filter((attachment) => attachment.type === "position")
          .map((attachment) => attachment.id);

        positionIds.forEach((posId) => {
          const position = positions.find((p) => p.id === posId);
          if (position && position.assigned_employees) {
            assignedEmployees = assignedEmployees.concat(position.assigned_employees);
          }
        });
      }
      this.assignments = assignedEmployees;
    },
    detachAction() {
      if (this.currentRole.type === "responsibility") {
        this.detachResponsibilityAction(this.currentRole);
      } else if (this.currentRole.type === "position") {
        this.detachRoleAction(this.currentRole);
      }
      this.showDetachDialog = false;
    },
    async detachRoleAction(data) {
      try {
        const payload = {
          parent_id: data.id,
        };
        await detachRoleAttachment(this.accountId, data.parentId, payload);
        await this.loadData();
      } catch (e) {
        console.error("e: ", e);
      }
    },
    async detachResponsibilityAction(data) {
      try {
        const payload = {
          parent_id: data.parentId,
        };
        await detachAttachments(this.accountId, data.id, payload);
        await this.loadData();
      } catch (e) {
        console.error("e: ", e);
      }
    },
    onCloseArchivePositionDialog() {
      this.showArchivedPositionDialog = false;
      this.archivePositionError = "";
    },
    async onArchivePosition() {
      this.archivePositionError = "";
      this.$loader.setAppLoading(true);
      try {
        const id = this.currentPosition?.id;
        const objTpye = "position";
        try {
          if (this.archiveAction === "archive") {
            await archivePosition(this.accountId, objTpye, id);
          } else if (this.archiveAction === "unarchive") {
            await unArchivePosition(this.accountId, objTpye, id);
          }
        } catch (e) {
          this.archivePositionError = positionActionErrorMessage(
            e,
            this.archiveAction
          );
          return;
        }
        this.showArchivedPositionDialog = false;
        this.currentPosition = null;
        if (this.archiveAction === "unarchive") {
          this.$notifications?.success?.("Position unarchived");
        }
        await this.loadPositionByID(this.accountId, this.$route.params.pId);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
  },
};
</script>

<style scoped>
.position-container {
  width: 100%;
  padding: 25px;
}
</style>
